
import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import { useFormik } from 'formik';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import axiosInstance from '../../../../Services/axiosCommon';

import TaskLayout from '../TaskLayout';
import { GetAccess } from '../../../../Components/Utils/roles';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import MultiEditSchedule from '../../TestingAndCommissioning/Schedules/MultiEditSchedule';
import ImportSchedule from '../../TestingAndCommissioning/Schedules/ImportSchedule';
import CloseIcon from '../../../../Components/Icons/Close';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import { NuDate, NuInput } from '../../../../Components/Utils/Input';
import MultiEditTask from './MultiEditTask';
import MobileMyTaskIndex from '../../../Mobile/Tasks/MyTasks/MobileTaskIndex';





function MyTaskIndex() {
  const { officeId } = useParams();
  
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);

  // const { value: Status, getData: refStatus } = useFetchMDIndex(
  //   `/dropdown/dropdown-details/`,
  //   "Status_Schedules",[showFilterDialog, showExport],
  //   () => showFilterDialog || showExport)

   const { data: user } = UseDropDown(`/user/new-drop-down`);
                                const { value: Status, getData: refStatus } = useFetchMataData(
                                 `/dropdown/dropdown-details/`,
                                 "Status_Task",[showFilterDialog, showExport],
                                 () => showFilterDialog || showExport)
                               
                                 const { value: Priority,getData:refPriority } = useFetchMataData(
                                  `/dropdown/dropdown-details/`,
                                  "priority"
                                ); 
  const [screenSize, setScreenSize] = useState({
         width: window.innerWidth,
       });
     
       useEffect(() => {
         const handleResize = () => {
           setScreenSize({
             width: window.innerWidth,
           });
         };
     
         window.addEventListener("resize", handleResize);
     
         return () => {
           window.removeEventListener("resize", handleResize);
         };
       }, []);

 const location = useLocation();
 const currentPage= location.state?.currentPage
 const searchQuery= location.state?.searchQuery
 const [page, setPage] = useState(currentPage||1)
 const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
 const state = location.state;
 const [filter, setFilter] = useState(
   state?.approvalStatus || state?.category ? true : false
 );
  const [filterProps, setFilterProps] = useState({
     
      startDateFrom:"",
      endDateFrom:"",
      priority:"",
      status:"",
      startDateTo:"",
      endDateTo:"",
      assignee:"",
      copyTo:""
      
      
     });
   const [params, setParams] = useState({
     page: page,
     per_page: pageCount,
     search:searchQuery||"",
    
     startDateFrom:"",
     endDateFrom:"",
     priority:"",
     status:"",
     startDateTo:"",
     endDateTo:"",
     assignee:"",
     copyTo:""
   });
  
   const clearFilter = ()=> {
     setParams({...params, startDateFrom:"",
      endDateFrom:"",
      priority:"",
      status:"",
      startDateTo:"",
      endDateTo:"",
      assignee:"",
      copyTo:""})
     
     formik.values.assignee=""
     formik.values.copyTo=""
     formik.values.startDateTo=""
     formik.values.endDateTo=""
  
     formik.values.startDateFrom=""
     formik.values.endDateFrom=""
     formik.values.priority=""
     formik.values.status=""
  
  
  
  
       setFilter(false)
   }
  
   const formik = useFormik({
     enableReinitialize: true,
     initialValues: filterProps,
     validateOnChange: false,
     validateOnBlur: false,
     validationSchema: yup.object({
       // email: yup.string().required('Email is required!'),
     }),
     onSubmit: async (value, { resetForm }) => {
        await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
       setParams({...params,assignee:value.assignee, startDateFrom:value.startDateFrom, startDateTo:value.startDateTo, endDateFrom:value.endDateFrom, priority:value.priority,
        status:value.status,copyTo:value.copyTo,endDateTo:value.endDateTo,})
       closeFilterDialog();
       setFilter(true)
       setFilterProps({
        startDateFrom:"",
     endDateFrom:"",
     priority:"",
     status:"",
     startDateTo:"",
     endDateTo:"",
     assignee:"",
     copyTo:""
       });
     }
   })
  

 const { data, totalCount, getData,dataLoading } = UseGetDataSearch( `/tasks/my-tasks-listing`,params);

 const defaultHeader = [
  {
    title: "Ref.",
    width: "10%",
    isLink: true,
    id: "id",
    link: `/tasks/my-tasks/view/`,
    field: "refNo",
    textAlign: "left",
    rowAlign: "left",
  },
  //  {
  //    title: "Activity",
  //    width: "15%",
  //    isLink: true,
  //    id: "id",
  //    link: `/tasks/my-tasks/view/`,
  //    field: "taskName",
  //    textAlign: "left",
  //    rowAlign: "left",
  //  },
    {
    title: "Type",
    width: "10%",
  
    field: "type",
    textAlign: "left",
    rowAlign: "left",
  },
   {
    title: "Priority",
    width: "10%",
  
    field: "priority",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Assignee",
    width: "10%",
  
    field: "assignedTo",
    textAlign: "left",
    rowAlign: "left",
  },
   {
    title: "Start Date",
    type: "date",
    width: "10%",
       field: "startDate",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Due Date",
    width: "10%",
    type: "date",
       field: "endDate",
    textAlign: "left",
    rowAlign: "left",
  },
  {
    title: "Duration",
    width: "10%",
      
    id: "id",
   
    field: "noOfDays",
    textAlign: "left",
    rowAlign: "left",
    
  },
   
   
   
   {
     title: "Status",
     width: "10%",
     field: "taskStatus",
     textAlign: "left",
     rowAlign: "left",
   },
  //  {
  //    title: "Consultant",
  //    width: "15%",
  //    field: "consultantName",
  //    textAlign: "center",
  //    rowAlign: "center",
  //  },
   // {
   //   title: "Salesman",
   //   width: "10%",
   //   field: "salesPersonName",
   //   textAlign: "center",
   //   rowAlign: "center",
   // },
  //  {
  //    title: "Status",
  //    width: "10%",
  //    field: "status",
  //    textAlign: "center",
  //    rowAlign: "center",
  //  },
   {
     title: "Action",
     width: "10%",
     field: "action",
     textAlign: "center",
     rowAlign: "center",
     contents:{
      //  fetcher:getData,
       id:"id",
       removeValue:"id",
       url:`/tasks/delete/`,
       moduleName:"Mytasks",
       from:`/tasks/my-tasks`,
       editLink:`/tasks/my-tasks/edit/`,
       viewLink:`/tasks/my-tasks/view/`

     }
   },
 ];
 const availableHeaders = [
 
 ];

 const [exportValue, setExportValue] = useState({
  taskName:"",
  startDate:"",
  endDate:"",
  priority:"",
  taskStatus:"",
 });
 const ExportFormik = useFormik({
   enableReinitialize: true,
   initialValues: exportValue,
   validateOnChange: false,
   validateOnBlur: false,
   onSubmit: async (value, { resetForm }) => {
     try {
       const response = await axiosInstance.get(
         `/customer-quotations/export-to-excel?status=${value.status}&startDateFrom=${value.startDateFrom}&startDateTo=${value.startDateTo}&endDateFrom=${value.endDateFrom}&endDateTo=${value.endDateTo}`,
         {
           responseType: "blob",
         }
       );

       const pdfBlob = new Blob([response.data], {
         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
       });

       const link = document.createElement("a");
       link.href = window.URL.createObjectURL(pdfBlob);
       link.download = `Schedules Report ${NuDate({
         value: new Date(),
         format: "DD-MMM-YYYY",
       })}.xlsx`;

       document.body.appendChild(link);
       link.click();

       link.parentNode.removeChild(link);
     } catch (error) {
       console.error("Error downloading the PDF:", error);
     }
   },
 });
 const closeFilterDialogebox = () => {
   setShowExport(false);
 };

 const [showEdit, setShowEdit] = useState(false)
 const [showDelete, setShowDelete] = useState(false)
 const [listofNumbers, setListofNumbers] = useState([])
 const [fullList, setFullList] = useState([])

 const selectOneFunction = (value) =>{ 
   let NewId;
   if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
     NewId = listofNumbers.filter(Temp=> Temp !== value);
     setListofNumbers(NewId)
   }else{
     setListofNumbers([...listofNumbers,value])
   }
 }

 const selectMultipleFunction = (e) =>{ 

   if(e.target.checked){
    console.log("if List", fullList);

     setListofNumbers(fullList)
   }else{
    console.log("else List", fullList);

     setListofNumbers([])
   }
   

     }

     useEffect(()=>{
       setParams({...params,page:page,per_page:pageCount})
      },[page,pageCount])
   

     const closeFilterDialog = () => {
       setShowFilterDialog(false);
     };
 const [showImportModal, setShowImportModal] = useState(false);


 const handleImportClick = () => {
   setShowImportModal(true);
 };

 const closeModal = () => {
   setShowImportModal(false);
 };

 useEffect(()=>{
   let tempArr = []
   data && data.forEach(i=>{
    
     tempArr.push(i?.id)
   });
   setFullList(tempArr)
 },[data])

 const [valueOfSearch,setValuesofSearch] = useState("")
  function searchFunction(e) {

    
    setValuesofSearch(e?.target?.value)
    setParams({ ...params, search: e?.target?.value, page:1 });
    setPage(1)
  }



 return (
   <>
   <TaskLayout
     setOpen={setShowImportModal}
     searchFun={searchFunction}
     searchValue={valueOfSearch}

     // getData={getData}
     isFilter={filter}
     neededSearch={true}
     newfilter={true}
 officeId={officeId}

     setFilterOpen={setShowFilterDialog}
     ClearFilter={clearFilter}
     CreateAccess={false}
           total={totalCount}

    //  ImportAccess={GetAccess("tasks_import")}
    //        ExportAccess={GetAccess("tasks_export")}
           setOpenExport={setShowExport}
     
     // officeId={officeId}
     // projectID={projectID}
       >


        
{
 screenSize.width <= "786" ?(<>
 <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
 <MobileMyTaskIndex
 data={data}
 total={totalCount}
 pageIndex={page}
 setPageIndex={setPage}
 dataCount={pageCount}
 setDataCount={setPageCount}
 officeId={officeId}
 getData={getData}

 />
 </div>
 </>):(<>


   <div className='w-full h-full  '>
     {/* <div className='w-full flex justify-between items-center'>
       <Breadcrumb
         items={[
           { name: "Procurement" },
           { name: "YPR" },
         ]} />
       <div className=' flex gap-2'>
       <SearchBar
             handleChange={(e) =>{
               setParams({ ...params, search: e.target.value, page:1 });
               setPage(1)
             }}
             value={params.search||searchQuery}
           />  <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
         {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
       
         {/* {GetAccess("purchase_request_create") && <ImportButton handleClick={handleImportClick} />} */}
         {/* {GetAccess("purchase_request_create") && <Link to={`/main/${officeId}/procurement/purchase-requests/create`}><CreateButton label='YPR' /></Link>}
       </div>
     </div> */}

     <CustomDataTable 
     fetcher={getData}
       data={data} 
       availableHeaders={availableHeaders} 
       defaultHeader={defaultHeader}
       bodyHeight='max-h-[calc(100vh-260px)]'
       height='h-[calc(100vh-160px)]'
       total={totalCount}
       pageIndex={page}
       setPageIndex={setPage}
       dataCount={pageCount}
       setDataCount={setPageCount}
       title='My Task'
       storageName="MyTaskTable"
       selectOneFunction={selectOneFunction}
       setShowDelete={setShowDelete}
       showDelete={showDelete}
       setShowEdit={setShowEdit}
       showEdit={showEdit}
       listofNumbers={listofNumbers} 
       hasMultiEdit={true}
       selectMultipleFunction={selectMultipleFunction}
       fullList={fullList}
       getById="id"
       editAccess="mytasks_edit"      
      //  deteleAccess="tasks_delete" 
       dataLoading={dataLoading}
       searchQuery={params?.search!=""?params?.search:""}
       // dateShow={true}
       />
   </div>

</>)}

 

       </TaskLayout>

       {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
             
             {/* <p className="py-2 px-6 text-m">Start Date</p> */}
                         
                           {/* <p className="py-2 px-6 text-m">End Date</p> */}
                          
                           
                         
                                     <p className="py-2 px-6 text-m"> Start Date</p>
                      <div className="md:flex  justify-between  w-full ">
                     
                                   <NuDate
                                     label="From"
                                     placeholder="Date"
                                     formik={formik}
                                     name="startDateFrom"
                                    
                                     width="w-full "
                                                 
                                    />
                                    <NuDate
                                     label="To"
                                     placeholder="Date"
                                     formik={formik}
                                     name="startDateTo"
                                    
                                     width="w-full "
                                                 
                                    />
                </div>
                <p className="py-2 px-6 text-m"> End Date</p>
                      <div className="md:flex  justify-between  w-full ">
                     
                                   <NuDate
                                     label="From"
                                     placeholder="Date"
                                     formik={formik}
                                     name="endDateFrom"
                                    
                                     width="w-full "
                                                 
                                    />
                                    <NuDate
                                     label="To"
                                     placeholder="Date"
                                     formik={formik}
                                     name="endDateTo"
                                    
                                     width="w-full "
                                                 
                                    />
                </div>
                <FormikSelectTwo
              label="Assigned To"
              Options={user}
              formik={formik}
              placeholder="Choose"
              name="assignee"

              width="w-full "
            />
            
                       <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"
             

              width="w-full "
            />
            <FormikSelectTwo
                          label="Status"
                         Options={Status}
                         formik={formik}
                         placeholder="Choose"
                         name="status"
                       
           
                         width="w-full"
                         displayProperty={"Status"}
                         propertyName={"Status_Task"}
                            getFunc={refStatus}
           
                       />
           
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" isLoading={formik.isSubmitting} />
              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiEditTask
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportSchedule
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}



       
   </>
 )
}

export default MyTaskIndex
